import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchSiteList } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const SiteListChartSlice: Slice<any, {}, "SiteListChartSlice"> = createSlice({
    name: "SiteListChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSiteList.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchSiteList.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchSiteList.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default SiteListChartSlice;
